/**
 * CinePacks Vault Renderer
 * Theme asset: assets/cinepacks-vault.js
 *
 * Activates on any page containing:
 *   <div id="cinepacks-vault" data-vault='{...JSON...}'></div>
 *
 * The JSON in data-vault should look like:
 * {
 *   "title": "What's Inside",
 *   "subtitle": "Everything included in the Master Bundle",
 *   "stats": [
 *     { "label": "Packs",  "value": "57"      },
 *     { "label": "Assets", "value": "4,700+"  },
 *     { "label": "Size",   "value": "100GB+"  },
 *     { "label": "Value",  "value": "$2,200+" }
 *   ],
 *   "categories": [
 *     {
 *       "name": "Transitions & Overlays",
 *       "packs": [
 *         { "name": "Foreground Transition FX", "price": "$49" }
 *       ]
 *     }
 *   ]
 * }
 */
(function () {
  'use strict';

  function init() {
    var mount = document.getElementById('cinepacks-vault');
    if (!mount || mount.dataset.cvRendered === '1') return;

    var raw = mount.getAttribute('data-vault');
    if (!raw) {
      console.warn('[cinepacks-vault] no data-vault attribute found');
      return;
    }

    var data;
    try {
      data = JSON.parse(raw);
    } catch (e) {
      console.error('[cinepacks-vault] invalid JSON in data-vault', e);
      return;
    }

    // Reset host element styling so theme CSS can't mangle it
    mount.setAttribute('style', 'all:initial;display:block;width:100%;');

    injectStyles();
    mount.innerHTML = render(data);
    bindFolders(mount);
    mount.dataset.cvRendered = '1';
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function render(data) {
    var title    = escapeHtml(data.title    || "What's Inside");
    var subtitle = escapeHtml(data.subtitle || '');
    var stats    = Array.isArray(data.stats) ? data.stats : [];
    var cats     = Array.isArray(data.categories) ? data.categories : [];

    var statsHtml = stats.map(function (s) {
      return '<div class="cv-stat">' +
               escapeHtml(s.label || '') +
               '<b>' + escapeHtml(s.value || '') + '</b>' +
             '</div>';
    }).join('');

    var foldersHtml = cats.map(function (cat) {
      var packs = Array.isArray(cat.packs) ? cat.packs : [];
      var rows = packs.map(function (p) {
        var name  = escapeHtml(p.name  || '');
        var price = escapeHtml(p.price || '');
        return '<div class="cv-pack">' +
                 '<div class="cv-pdot"></div>' +
                 '<span class="cv-pname">' + name + '</span>' +
                 (price ? '<span class="cv-pprice">' + price + '</span>' : '') +
               '</div>';
      }).join('');

      return '<div class="cv-folder">' +
               '<div class="cv-fhead">' +
                 '<div class="cv-ficon">' +
                   '<div class="cv-ficon-tab"></div>' +
                   '<div class="cv-ficon-body"></div>' +
                 '</div>' +
                 '<div class="cv-fname">' + escapeHtml(cat.name || '') + '</div>' +
                 '<div class="cv-fcount">' + packs.length + ' pack' + (packs.length === 1 ? '' : 's') + '</div>' +
                 '<div class="cv-farrow">&#9654;</div>' +
               '</div>' +
               '<div class="cv-fbody">' + rows + '</div>' +
             '</div>';
    }).join('');

    return (
      '<div class="cv-wrap">' +
        '<div class="cv-accent"></div>' +
        '<div class="cv-header">' +
          '<div class="cv-title"><span>///</span> ' + title + '</div>' +
          (subtitle ? '<div class="cv-sub">' + subtitle + '</div>' : '') +
        '</div>' +
        (statsHtml ? '<div class="cv-stats">' + statsHtml + '</div>' : '') +
        '<div class="cv-folders">' + foldersHtml + '</div>' +
      '</div>'
    );
  }

  function bindFolders(root) {
    var folders = root.querySelectorAll('.cv-folder');
    for (var i = 0; i < folders.length; i++) {
      (function (folder) {
        var head = folder.querySelector('.cv-fhead');
        head.addEventListener('click', function () {
          folder.classList.toggle('open');
        });
      })(folders[i]);
    }
  }

  function injectStyles() {
    if (document.getElementById('cv-styles')) return;
    var style = document.createElement('style');
    style.id = 'cv-styles';
    style.textContent = [
      "@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Prompt:ital,wght@0,800;0,900;1,800;1,900&family=Space+Mono:wght@400;700&display=swap');",

      // Override product_effects wrapper constraints if vault is dropped inside one
      ".product__effects_images, .product_effects_img, .product__effects_images-wrapper { max-width:100% !important; width:100% !important; padding:0 !important; text-align:center !important; }",

      "#cinepacks-vault * { box-sizing:border-box; margin:0; padding:0; }",

      "#cinepacks-vault .cv-wrap { font-family:'Space Mono',monospace; background:#000; border:1px solid #1a1a1a; max-width:100%; width:100%; margin:0 auto; overflow:hidden; }",
      "#cinepacks-vault .cv-accent { height:3px; background:#cc0000; }",

      "#cinepacks-vault .cv-header { padding:28px 28px 20px; border-bottom:1px solid #1a1a1a; }",
      "#cinepacks-vault .cv-title { font-family:'Prompt','Bebas Neue',sans-serif; font-size:28px; font-weight:900; font-style:italic; letter-spacing:0.02em; color:#fff; text-transform:uppercase; margin:0 0 6px; }",
      "#cinepacks-vault .cv-title span { color:#cc0000; }",
      "#cinepacks-vault .cv-sub { font-size:10px; color:#999; letter-spacing:0.2em; text-transform:uppercase; }",

      "#cinepacks-vault .cv-stats { display:flex; border-bottom:1px solid #1a1a1a; background:#080808; }",
      "#cinepacks-vault .cv-stat { flex:1; padding:14px 0; text-align:center; font-size:9px; color:#999; text-transform:uppercase; letter-spacing:0.12em; border-right:1px solid #1a1a1a; }",
      "#cinepacks-vault .cv-stat:last-child { border-right:none; }",
      "#cinepacks-vault .cv-stat b { display:block; font-family:'Prompt','Bebas Neue',sans-serif; font-weight:800; font-style:italic; font-size:18px; color:#cc0000; margin-top:4px; letter-spacing:0.02em; }",

      "#cinepacks-vault .cv-folders { padding:6px; }",
      "#cinepacks-vault .cv-folder { border:1px solid #141414; margin:3px 0; background:#0a0a0a; transition:border-color 0.2s; }",
      "#cinepacks-vault .cv-folder:hover { border-color:#2a0a0a; }",
      "#cinepacks-vault .cv-folder.open { border-color:#cc0000; background:#0d0d0d; }",

      "#cinepacks-vault .cv-fhead { display:flex; align-items:center; padding:13px 18px; gap:14px; cursor:pointer; user-select:none; }",
      "#cinepacks-vault .cv-ficon { width:24px; height:18px; position:relative; flex-shrink:0; }",
      "#cinepacks-vault .cv-ficon-tab { position:absolute; top:0; left:0; width:10px; height:5px; background:#cc0000; border-radius:2px 2px 0 0; }",
      "#cinepacks-vault .cv-ficon-body { position:absolute; top:4px; left:0; width:24px; height:14px; background:#cc0000; border-radius:0 2px 2px 2px; opacity:0.8; }",
      "#cinepacks-vault .cv-folder.open .cv-ficon-body { opacity:1; }",

      "#cinepacks-vault .cv-fname { font-family:'Prompt','Bebas Neue',sans-serif; font-size:14px; font-weight:800; font-style:italic; letter-spacing:0.06em; color:#888; flex:1; text-transform:uppercase; }",
      "#cinepacks-vault .cv-folder.open .cv-fname { color:#fff; }",
      "#cinepacks-vault .cv-folder:hover .cv-fname { color:#ccc; }",

      "#cinepacks-vault .cv-fcount { font-size:9px; color:#666; letter-spacing:0.1em; text-transform:uppercase; }",
      "#cinepacks-vault .cv-folder.open .cv-fcount { color:#999; }",

      "#cinepacks-vault .cv-farrow { color:#555; font-size:10px; transition:transform 0.25s ease, color 0.2s; }",
      "#cinepacks-vault .cv-folder.open .cv-farrow { transform:rotate(90deg); color:#cc0000; }",

      "#cinepacks-vault .cv-fbody { display:none; padding:2px 18px 14px; border-top:1px solid #1a1a1a; }",
      "#cinepacks-vault .cv-folder.open .cv-fbody { display:block; }",

      "#cinepacks-vault .cv-pack { display:flex; align-items:center; gap:10px; padding:7px 10px; margin:3px 0; background:#060606; border:1px solid #111; transition:all 0.15s; text-decoration:none; cursor:default; }",
      "#cinepacks-vault .cv-pack:hover { border-color:#cc0000; background:#120606; }",
      "#cinepacks-vault .cv-pdot { width:5px; height:5px; background:#cc0000; border-radius:50%; flex-shrink:0; }",
      "#cinepacks-vault .cv-pname { font-size:11px; color:#999; flex:1; transition:color 0.15s; }",
      "#cinepacks-vault .cv-pack:hover .cv-pname { color:#fff; }",
      "#cinepacks-vault .cv-pprice { font-size:10px; color:#555; transition:color 0.15s; }",
      "#cinepacks-vault .cv-pack:hover .cv-pprice { color:#cc0000; }",

      "@media screen and (max-width:600px) {",
      "  #cinepacks-vault .cv-title { font-size:22px; }",
      "  #cinepacks-vault .cv-stat b { font-size:14px; }",
      "  #cinepacks-vault .cv-stats { flex-wrap:wrap; }",
      "  #cinepacks-vault .cv-stat { flex:1 1 33%; border-bottom:1px solid #1a1a1a; }",
      "}"
    ].join('\n');
    document.head.appendChild(style);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
